import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../Components/consts'

export const LeaderboardWrapper = styled('div')(({ theme }) => ({
  backgroundColor: colors.white,
  padding: 10,
  borderRadius: 8,
  flex: '1 1 45%',
  minWidth: 300,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  [theme.breakpoints.down('sm')]: {
    padding: 8,
  },
}))

export const Table = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
})

export const TableHeader = styled('thead')({
  backgroundColor: colors.black,
  color: colors.white,
  borderRadius: '8px 8px 0 0',
})

type TableHeaderCellProps = {
  align?: 'left' | 'center' | 'right'
  width?: string
}

export const TableHeaderCell = styled('th')<TableHeaderCellProps>(
  ({ theme, align, width }) => ({
    padding: '6px 8px',
    textAlign: align || 'left',
    fontSize: fontSizes.medium,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    width: width || 'auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
    },
  })
)

export const TableRow = styled('tr')({
  '&:nth-of-type(odd)': {
    backgroundColor: colors.offWhite,
  },
  '&:nth-of-type(even)': {
    backgroundColor: colors.white,
  },
  '&:last-child': {
    borderBottom: 'none',
  },
})

type TableCellProps = {
  align?: 'left' | 'center' | 'right'
  vAlign?: 'top' | 'middle' | 'bottom'
}

export const TableCell = styled('td')<TableCellProps>(({ theme, align, vAlign }) => ({
  padding: '4px 8px',
  textAlign: align || 'left',
  verticalAlign: vAlign || 'middle',
  fontSize: fontSizes.medium,
  fontWeight: 'bold',
  color: colors.text,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.small,
  },
}))

export const FanInfoCon = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const NameInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  '& .name': {
    fontSize: fontSizes.medium,
    color: colors.text,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .location': {
    fontSize: fontSizes.small,
    color: colors.text,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
    },
  },
}))

export const MPHText = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: fontSizes.semiLarge,
  color: colors.text,
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.medium,
  },
}))
const BaseTeamIcon = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: 25,
  height: 38,
  marginRight: 5,
  verticalAlign: 'middle',
  [theme.breakpoints.down('sm')]: {
    width: 20,
    height: 28,
  },
}))

export const TeamIcon = styled(BaseTeamIcon)({
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
})

export const TeamIconPlaceholder = styled(BaseTeamIcon)({
  backgroundColor: colors.white,
  borderRadius: '50%',
})
